import React, { useEffect, useRef, useState } from 'react';
import './style.css';
import Spinner from '../../../global-components/src/components/spinner/spiner';
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import SuccessCatAlert from '../../alert-success-cat/alert-success-cat';
import { Post } from '../../../types';
import { useAuth, useMessage } from '../../../global-components/src';
import { LIMIT_TEXT_POST as LIMIT_TEXT_POST_ENV } from '../../../utils/vars';
import EmojiPickerNative from '../../Textarea/Emojis/emoji-picker-native';
import { Smile } from 'lucide-react';
import { PACOCA_API_URL } from '../../../global-components/src/utils/vars';
import { useTranslation } from 'react-i18next';

interface EditPostProps {
    post: Post | null;
    onEdit?: (newText: string, gifUrl?: string | null) => void;
}

const EditPost: React.FC<EditPostProps> = ({ post, onEdit }) => {
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [text, setText] = useState(post?.text ? post?.text : "");
    const [isLimitExceeded, setIsLimitExceeded] = useState(false);
    const [success, setSuccess] = useState("");
    const [showEmoji, setShowEmoji] = useState(false);
    const [gifUrl, setGifUrl] = useState<string | null>(post?.gif_url ?? null);
    const closeRef = useRef<HTMLButtonElement | null>(null);
    const { setMessage } = useMessage();
    const { user, token } = useAuth();
    const { t } = useTranslation();
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const buttonRef = useRef<HTMLDivElement | null>(null);
    const minHeight = 150;
    const [LIMIT_TEXT_POST, setLImitTextPost] = useState(LIMIT_TEXT_POST_ENV);

    const adjustTextareaHeight = () => {
        if (textareaRef.current) {
            textareaRef.current.style.height = "auto"; // Reseta a altura para calcular corretamente
            const newHeight = Math.max(minHeight, textareaRef.current.scrollHeight); // Garante a altura mínima
            textareaRef.current.style.height = `${newHeight}px`;
        }
    };

    useEffect(() => {
        adjustTextareaHeight(); // Ajusta a altura ao montar o componente ou mudar o texto
    }, [text]);

    useEffect(() => {
  const modal = document.getElementById("modal-edit-post");
  if (!modal) return;

  const handleShown = () => {
        // força o ajuste depois que o modal aparece
        setTimeout(() => adjustTextareaHeight(), 10);
    };

    modal.addEventListener("shown.bs.modal", handleShown);

    return () => {
        modal.removeEventListener("shown.bs.modal", handleShown);
    };
    }, []);

    
    useEffect(() => {
        if(user?.stamps?.includes("blue"))
            setLImitTextPost(LIMIT_TEXT_POST_ENV * 2);
    }, [user])

    useEffect(() => {
        setText(post?.text ? post?.text : "")
        setGifUrl(post?.gif_url ?? null)
    }, [post]);

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        const url = PACOCA_API_URL + "/posts/" + post?.id
        event.preventDefault(); // Impede o envio do formulário
        setLoading(true);

        // Verifica se há texto ou arquivos selecionados
        if (!text && !gifUrl) {
            setErrorMessage("Escreva algo");
            setLoading(false); // Reabilita o botão caso falhe a validação
            return;
        }

        // Se passou na validação, pode enviar
        setErrorMessage("");

        try {
            await axios.patch(url, { text, gif_url: gifUrl }, {
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}` // Adicione o token aqui
                }
            })

            cancelPost()
            if (onEdit) onEdit(text, gifUrl)
            setMessage(t("post.edited"), "success")

            if (closeRef.current)
                closeRef.current.click()

        } catch (err: any) {
            console.error(err.response.data.message);
            if (err.response) {
                // O servidor respondeu com um código de erro
                console.error("Erro no servidor:", err.response.status, err.response.data);
                setErrorMessage(err.response.data.message || "Erro ao fazer post!");
            } else if (err.request) {
                // A requisição foi feita, mas não houve resposta
                console.error("Nenhuma resposta do servidor:", err.request);
                setErrorMessage(t("generics.errors.genericServerError"));
            } else {
                // Outro tipo de erro (ex: erro de configuração)
                console.error("Erro inesperado:", err.message);
                setErrorMessage("Ocorreu um erro inesperado!");
            }

            if (err.status == 429 && err.message.blocked)
                setErrorMessage(t("generics.errors.tooManyRequests", { minutes: err.remaining }))

            if (err.status == 429)
                setErrorMessage(t("generics.errors.tooManyRequestsGeneric"))

            if (err.status == 401)
                setErrorMessage(t("generics.errors.sessionExpired"))

        } finally {
            setLoading(false);
        }
    };

    const limitePost = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        const newText = event.target.value;
        setText(newText);
        setIsLimitExceeded(newText.length > LIMIT_TEXT_POST);
    }

    const cancelPost = () => {
        setLoading(false)
        setErrorMessage("");
        setText("");
        setGifUrl(null);
        setIsLimitExceeded(false);
    }

    const updateText = (newText: string) => {
        setText(newText); // Atualiza o estado com o novo texto
    };

    return (
        <>
            <div className="col-10">
                <form className="form-post" onSubmit={handleSubmit} id='form-edit-post'>
                    <div className="modal fade" id="modal-edit-post" aria-labelledby={`modal-edit-post-${post?.id}`} aria-hidden="true">
                        <div className="modal-dialog cover-mobile">
                            <div id="username-suggestions"></div>
                            <div className="modal-content">
                                <div className="modal-header modal-header-add-post" style={{ borderBottom: "5!important" }}>
                                    <h4 className="modal-title" id="modal-edit-post">{t("post.editTitle")}</h4>
                                    <button ref={closeRef} type="button" className="btn-close btn-dark" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                                <div className="modal-body" style={{paddingLeft: 0, paddingRight: 0, paddingTop: 0}}>
                                    <div className="user-suggestions user-suggestions-new-post" style={{ display: "none", position: "absolute", background: "white", border: "1px solid #ccc", zIndex: "1000", maxHeight: "200px", overflowY: "auto", top: "254px" }}></div>
                                    <textarea
                                        ref={textareaRef}
                                        value={text}
                                        onChange={(e) => limitePost(e)}
                                        // id="comment-text"
                                        className={`form-control text-with-emoji text-comment-big text-comment mb-2 ${isLimitExceeded ? "is-invalid" : ""}`}
                                        style={{ color: isLimitExceeded ? "red" : "inherit" }}
                                        placeholder="Quais as novidades de hoje?"
                                    />
                                    <EmojiPickerNative
                                        show={showEmoji}
                                        setShow={setShowEmoji}
                                        onSelect={(emoji) => setText(prev => prev + emoji)}
                                        handleClickGif={setGifUrl}
                                        bottom="0"
                                    />
                                    {gifUrl && (
                                        <div className="edit-post-gif-preview">
                                            <img src={gifUrl} alt="GIF selecionado" />
                                            <button type="button" onClick={() => setGifUrl(null)} aria-label="Remover GIF">×</button>
                                        </div>
                                    )}
                                    <div className='div-info-textarea'>
                                        <div className='cursor-pointer icon-add-emoji' ref={buttonRef} onClick={() => setShowEmoji(true)}>
                                            <Smile className='icon-add-emoji' />
                                        </div>

                                        <div className="user-select-none limite-post" style={{ color: isLimitExceeded ? "red" : "inherit" }}>
                                            {text.length}/{LIMIT_TEXT_POST}
                                        </div>
                                    </div>

                                    <div className="invalid-feedback invalid-feedback-comment-text" style={{ display: "block" }}>
                                        {errorMessage}
                                    </div>

                                    <div className="modal-footer" style={{ padding: "0" }}>
                                        <div className="loading-post"></div>
                                            <div className="row" style={{width: "100%", justifyContent: "end"}}>
                                                <div className="col-6 col-md-3 col-lg-3 col-xl-3 col-add-post-btn" style={{ paddingLeft: "5px", paddingRight: "0px" }}>
                                                    <button type="button" className="btn btn-subimit-post btn-secondary btn-w-100" onClick={cancelPost} data-bs-dismiss="modal">Cancelar</button>
                                                </div>

                                                <div className="col-6 col-md-3 col-lg-3 col-xl-3 col-add-post-btn" style={{ paddingRight: "5px", paddingLeft: "5px" }}>

                                                    <button type="submit" className={`btn-subimit-post btn btn-blue btn-w-100`} disabled={loading || isLimitExceeded}>
                                                        {loading ? (
                                                            <>
                                                                <Spinner />
                                                            </>
                                                        ) : (
                                                            <>Editar</>
                                                        )}
                                                    </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
};

export default EditPost;
